import { Icon } from "@iconify/react"
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { Button, Card, Col, Descriptions, Divider, Flex, Grid, Input, Pagination, Row, Table, Tag, Typography } from "antd"
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { customerService } from "../../../services/customer.service";
import useTitleStore from "../../../store/titleStore";
import { useTableHeight } from "../../../hooks/useTableHeight";
import useDebounce from "../../../hooks/useDebounce";
import { format } from "date-fns";
import pallete from "../../../utils/pallete";

export default function CustomerVerificationIndex() {

  const breakpoint = Grid.useBreakpoint()

  const navigate = useNavigate();

  const { setTitle } = useTitleStore();

  const tableHeight = useTableHeight();

  const [keyword, setKeyword] = useState("");
  const debouncedKeyword = useDebounce(keyword, 500);
  const [dataParams, setDataParams] = useState({
    limit: 10,
    page: 1,
    query: debouncedKeyword
  })

  useEffect(() => {
    setTitle("Customer Terverifikasi");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDataParams((prev) => ({
      ...prev,
      query: debouncedKeyword
    }));
  }, [debouncedKeyword]);

  const { data: customerData, isLoading, isRefetching } = useQuery({
    queryKey: ['verificated-customers', dataParams],
    queryFn: () => customerService.fetchAllVerificationCustomer(dataParams),
    placeholderData: keepPreviousData,
  })


  const handleChangePage = (page, pageSize) => {
    setDataParams({
      ...dataParams,
      limit: pageSize,
      page
    })
  }

  const customer = customerData?.data;
  const pagination = customerData?.pagination || { total: 0, page: 1 };

  const columns = [
    {
      title: 'No',
      align: 'center',
      width: 80,
      fixed: breakpoint.md && 'left',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Nama',
      dataIndex: 'name',
      width: 180,
      fixed: breakpoint.md && 'left',
    },
    {
      title: 'Nomen',
      dataIndex: 'nomen',
      width: 120
    },
    {
      title: 'No Handphone',
      dataIndex: 'phoneNumber',
      width: 150
    },
    {
      title: 'No Handphone Baru',
      dataIndex: 'newPhoneNumber',
      width: 150
    },
    {
      title: 'Status',
      dataIndex: 'verificationStatus',
      render: val => {
        switch (val) {
          case 'pending':
            return <Tag color="orange" >Menunggu Verifikasi</Tag>
          case 'accepted':
            return <Tag color="green" >Terverifikasi</Tag>
          case 'rejected':
            return <Tag color="red" >Ditolak</Tag>
          default:
            return <Tag color="default" >Belum Terverifikasi</Tag>
        }
      },
      width: 120,
    },
    {
      title: 'Waktu Verifikasi',
      dataIndex: 'verifiedAt',
      width: 150,
      render: val => val ? format(new Date(val), 'dd-MM-yyyy HH:mm') : '-'
    },
    {
      className: 'last-cell-p',
      title: 'Aksi',
      align: 'right',
      width: 80,
      fixed: 'right',
      render: (record) => (
        <Button
          icon={<Icon icon="solar:eye-bold-duotone" width="18" height="18" />}
          color="primary"
          variant="filled"
          onClick={() => navigate('/user-management/customer-verification/detail/' + record.id)}
          size=""
        />
      )
    },
  ]

  return (
    <>
      <Card
        styles={{
          body: {
            paddingLeft: 0,
            paddingRight: 0
          }
        }}
      >
        <Flex gap={20} justify="space-between" style={{ paddingInline: 24, marginBottom: 24 }} >
          <Input
            style={{ width: 320 }}
            prefix={<Icon icon="hugeicons:search-01" width="16" height="16" />}
            placeholder="cari berdasarkan nama, no handphone atau email"
            onChange={e => setKeyword(e.target.value)}
            value={keyword}
          />
        </Flex>
        <Table
          columns={columns}
          size="small"
          loading={isLoading || isRefetching}
          rowKey={'id'}
          scroll={{ y: tableHeight }}
          dataSource={customer}
          pagination={false}
        // expandable={{
        //   expandRowByClick: true,
        //   expandedRowRender: record => (
        //     <div style={{
        //       padding: 20, backgroundColor: '#fff', margin: -8, borderLeft: '4px solid ' + pallete.primary.main, paddingInline: 40, paddingBottom: 40, boxShadow: 'inset 0px 16px 21px -22px rgba(70, 70, 70, 0.44)', borderBottom: '1px solid ' + pallete.grey[300]
        //     }} >
        //       <Typography.Text style={{ fontWeight: 600, fontSize: 15, color: pallete.primary.darker }} >
        //         Detail Pelanggan
        //       </Typography.Text>
        //       <Divider style={{ marginTop: 10, marginBottom: 10 }} />
        //       <Row gutter={[0, 20]} >
        //         <Col span={8} >
        //           <Typography.Text type="secondary" style={{ display: 'block', fontSize: 12 }} >
        //             Nama Lengkap
        //           </Typography.Text>
        //           <Typography.Text style={{ color: '#454F5B', fontWeight: 400 }} >
        //             {record?.name}
        //           </Typography.Text>
        //         </Col>
        //         <Col span={16} >
        //           <Typography.Text type="secondary" style={{ display: 'block', fontSize: 12 }} >
        //             Alamat
        //           </Typography.Text>
        //           <Typography.Text style={{ color: '#454F5B', fontWeight: 400 }} >
        //             {record?.address}
        //           </Typography.Text>
        //         </Col>
        //         <Col span={8} >
        //           <Typography.Text type="secondary" style={{ display: 'block', fontSize: 12 }} >
        //             Nomen
        //           </Typography.Text>
        //           <Typography.Text style={{ color: '#454F5B', fontWeight: 400 }} >
        //             {record?.nomen}
        //           </Typography.Text>
        //         </Col>
        //         <Col span={8} >
        //           <Typography.Text type="secondary" style={{ display: 'block', fontSize: 12 }} >
        //             Area Bisnis
        //           </Typography.Text>
        //           <Typography.Text style={{ color: '#454F5B', fontWeight: 400 }} >
        //             {record?.ab}
        //           </Typography.Text>
        //         </Col>
        //         <Col span={8} >
        //           <Typography.Text type="secondary" style={{ display: 'block', fontSize: 12 }} >
        //             Rayon
        //           </Typography.Text>
        //           <Typography.Text style={{ color: '#454F5B', fontWeight: 400 }} >
        //             {record?.rayon}
        //           </Typography.Text>
        //         </Col>
        //         <Col span={8} >
        //           <Typography.Text type="secondary" style={{ display: 'block', fontSize: 12 }} >
        //             No Handphone
        //           </Typography.Text>
        //           <Typography.Text style={{ color: '#454F5B', fontWeight: 400 }} >
        //             {record?.phoneNumber}
        //           </Typography.Text>
        //         </Col>
        //         <Col span={8} >
        //           <Typography.Text type="secondary" style={{ display: 'block', fontSize: 12 }} >
        //             No Handphone Baru
        //           </Typography.Text>
        //           <Typography.Text style={{ color: '#454F5B', fontWeight: 400 }} >
        //             {record?.newPhoneNumber}
        //           </Typography.Text>
        //         </Col>
        //         <Col span={8} >
        //           <Typography.Text type="secondary" style={{ display: 'block', fontSize: 12 }} >
        //             Status
        //           </Typography.Text>
        //           <Typography.Text style={{ color: '#454F5B', fontWeight: 400 }} >
        //             {record?.isVerified ? <Tag color="green" >Terverifikasi</Tag> : <Tag color="red" >Belum Terverifikasi</Tag>}
        //             <span style={{ fontWeight: 300 }} >
        //               {record.verifiedAt ? format(new Date(record.verifiedAt), 'dd-MM-yyyy HH:mm') : '-'}
        //             </span>
        //           </Typography.Text>
        //         </Col>
        //       </Row>
        //       {/* <Card>
        //       </Card> */}
        //     </div >
        //   ),
        // }}
        />
        < Pagination
          style={{ marginInline: 24, marginTop: 16 }}
          total={pagination.total}
          showSizeChanger={{
            showSearch: false,
          }}
          pageSizeOptions={['10', '20', '50']}
          current={pagination.page}
          pageSize={dataParams.limit}
          align="end"
          onChange={handleChangePage}
        />
      </Card >
    </>
  )
}